module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/homepod-022c481cc24575a963c1b0be67bd7781.svg";